import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../Utils/Function';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import BackgroundEffect from './BackgroundEffect';

const Login = () => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const response = await axios.post(`${BASE_URL}/users/login.php`, {
                mobile_no: phone,
                user_password: password
            });

            if (response.data.status === 200) {
                const userData = response.data.data;

                // Restrict login to role '1' (Client) only
                if (userData.role !== '1') {
                    setError('Access Restricted: This login is for client accounts only.');
                    setIsLoading(false);
                    return;
                }

                localStorage.setItem('user', JSON.stringify(userData));

                // Check if we have a destination to return to
                const redirectTo = location.state?.redirectTo;
                const bookingState = location.state?.bookingState;

                if (redirectTo) {
                    navigate(redirectTo, { state: bookingState });
                } else {
                    navigate('/');
                }
            } else {
                setError(response.data.message || 'Invalid credentials');
            }
        } catch (err) {
            if (err.response) {
                // The server responded with a status code outside the 2xx range
                setError(err.response.data?.message || 'Invalid credentials');
            } else if (err.request) {
                // The request was made but no response was received
                setError('Unable to connect to server. Please try again.');
            } else {
                // Something happened in setting up the request
                setError('An error occurred. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-container d-flex align-items-center justify-content-center">
            <BackgroundEffect />
            <div className="auth-card p-4 p-md-5">
                <div className="text-center mb-4">
                    <h2 className="section-head-main mb-2" style={{ fontSize: '2rem' }}>WELCOME BACK</h2>
                    <div style={{ width: '40px', height: '2px', backgroundColor: 'var(--secondary-color)', margin: '0 auto' }}></div>
                </div>

                {error && <div className="alert alert-danger bg-transparent text-danger border-danger small p-2 mb-4">{error}</div>}

                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="section-index mb-2" style={{ fontSize: '0.7rem' }}>PHONE NUMBER</label>
                        <div className="auth-input-wrapper">
                            <input
                                type="tel"
                                className="auth-input w-100"
                                placeholder="Enter your phone number"
                                value={phone}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    if (val.length <= 10) setPhone(val);
                                }}
                                required
                            />
                        </div>
                    </div>
                    <div className="mb-5">
                        <label className="section-index mb-2" style={{ fontSize: '0.7rem' }}>PASSWORD</label>
                        <div className="auth-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="auth-input"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="btn-book-now w-100 py-3" disabled={isLoading}>
                        {isLoading ? 'SIGNING IN...' : 'LOGIN TO ACCOUNT'}
                    </button>
                </form>

                <div className="text-center mt-4 pt-2">
                    <p className="m-0" style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>
                        Don't have an account? <Link to="/register" style={{ color: 'var(--secondary-color)', textDecoration: 'none' }}>Register Now</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
